// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2p-0";
export var spinnerContainer = "_2p-1";